
export default {
  loadBusiData: function loadBusiData(newData, busiData) {
    if (busiData.BUSI_CODE == "QS420") {
      newData.ID_ISS_AGCY = "";
      newData.CORP_QUAL_ID_NAME = newData.CORP_QUAL_ID_NAME || "";
      newData.CORP_QUAL_ID_CODE = newData.CORP_QUAL_ID_CODE || "";
      newData.CORP_QUAL_ID_EXP_DATE = newData.CORP_QUAL_ID_EXP_DATE || "";
      newData.CORP_QUAL_ID_ISS_AGCY_PRO = newData.CORP_QUAL_ID_ISS_AGCY_PRO || "";
      newData.AGENT_FAX = newData.AGENT_FAX || "";
    }
    return newData;
  }

};


//////////////////
// WEBPACK FOOTER
// ./src/assets/busi-paper/prints/GUOTOU/0x3.js
// module id = 1135
// module chunks = 2